import { StyledFooter, StyledDialog, StyledDialogContent } from "./styles";
import { useTranslation } from "react-i18next";
import { TextButton } from "../../components/Buttons/TextButton";
import { useTheme } from "../theme/useTheme";
import Notification, { INotification } from "./Notification";
import { NotificationDetail } from "./NotificationDetail";
import { useApplicationStore } from "../home/ApplicationStore";
import { useNotificationStore } from "./NotificationStore";
import { useSideSheetStore } from "../components/SideSheet/useSideSheetStore";
import { useWebViewStore } from "../webview/useWebViewStore";
import { useUpdateNotification } from "./useNotification";
import { useAnalytics } from "../third-party-integration/amplitude";
import { AMPLITUDE_EVENTS } from "../../constants";
import NotificationSheetContainer from "./NotificationSheetContainer";

const OutageNotificationDialog = (props: {
  isOpen: boolean;
  onClose: Function;
}): JSX.Element => {
  const { darkMode } = useTheme();
  const { t } = useTranslation();
  const { applications } = useApplicationStore();
  const notifications = useNotificationStore(
    (state: any) => state.notifications
  );
  const count = useNotificationStore((state: any) => state.count);
  const read = useNotificationStore((state: any) => state.read);
  const title =
  count > 0
    ? `${t("notification.sheet.title")} (${count})`
    : t("notification.sheet.title");

  const { openSideSheet, closeSideSheet } = useSideSheetStore();
  const { setCustomWebView } = useWebViewStore();
  const { mutate: updateNotification } = useUpdateNotification();
  const { trackEvent } = useAnalytics();
  const firstNotification = 0;

  const handleNotificationSelect = (notification: INotification) => {
    props.onClose();
    if (notification.ctaUrl) {
      setCustomWebView({ url: notification.ctaUrl });
      closeSideSheet();
    } else {
      openSideSheet({ body: <NotificationDetail notification={notification} /> });
    }
    if (!notification.read) {
      updateNotification({ notification, read: true });
      read(notification, true);
    }
    trackEvent(AMPLITUDE_EVENTS.NOTIFICATION_DETAIL, {
      Title: notification?.title,
      Type: notification?.type,
      Action: "Open",
    });
  };

  return (
    <div>
      <StyledDialog
        isOpen={props.isOpen}
        id="notification-dialog"
        data-testid="notification-dialog"
        onClose={props.onClose}
        title={t("notification.dialog.title")}
      >
        <StyledDialogContent>
          <Notification
            data-testid={"notification-item"}
            applications={applications}
            notification={notifications[firstNotification]}
            onSelect={handleNotificationSelect}
          />
        </StyledDialogContent>
        <StyledFooter
          style={{
            padding: "16px",
          }}
        >
          <div />
          <TextButton
            darkMode={darkMode}
            text={t("notification.dialog.linkAll")}
            onClick={() => {
              props.onClose();
              openSideSheet({title:title,body:(<NotificationSheetContainer />)});
            }}
          />
        </StyledFooter>
      </StyledDialog>
    </div>
  );
};
export default OutageNotificationDialog;
